import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var avatarComponentName = 'QuantumAvatar';
export function getAvatarUtilityClass(slot) {
    return generateUtilityClass(avatarComponentName, slot);
}
export var avatarClasses = generateUtilityClasses(avatarComponentName, ['root', 'img', 'fallbackIcon']);
